'use strict';

const capitalise = string => string.charAt(0).toUpperCase() + string.slice(1);
const convertCamelCaseToSentenceCase = camelCase => camelCase.replace(/([A-Z])/g, ' $1').toLowerCase();
const getPluralNoun = function (array, singular) {
  let plural = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : `${singular}s`;
  return array.length > 1 ? plural : singular;
};
const slugify = string => string.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
.replace(/^-+/, '') // Trim - from start of text
.replace(/-+$/, ''); // Trim - from end of text

module.exports = {
  capitalise,
  convertCamelCaseToSentenceCase,
  getPluralNoun,
  slugify
};